// @ts-nocheck

// Import youtubeIframe
import * as YouTubeIframeLoader from 'youtube-iframe'

// import splitText
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import SplitText from "../components/splitText";
import AOS from 'aos';
import 'aos/dist/aos.css';
gsap.registerPlugin(ScrollTrigger);

// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay, EffectFade, Grid} from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const emails = ['temp-mail.org', 'correotemporal.org', 'mohmal.com', 'yopmail.com', 'tempail.com', 'emailondeck.com', 'emailtemporalgratis.com', 'crazymailing.com', 'tempr.email', 'bupmail.com', 'guerrillamail.com', 'temp-mail.io', 'es.emailfake.com', 'nowmymail.com', '10minutemail.net', 'es.getairmail.com', 'mailf5.com', 'flashmail.it', '10minemail.com', 'mailcatch.com', 'temp-mails.com', 'spambox.us', 'mailnull.com', 'incognitomail.com', 'ssl.trashmail.net', 'trashmail.net', 'mailinator.com', 'tempinbox.com', 'filzmail.com', 'dropmail.me', 'spam4.me', 'cs.email', 'one-off.email', 'throwawaymail.com', 'emailtemporal.org', 'maildrop.cc', 'mailforspam.com', 'trashmail.com', 'teleworm.us', 'superrito.com', 'rhyta.com', 'jourrapide.com', 'gustr.com', 'fleckens.hu', 'einrot.com', 'cuvox.de', 'dayrep.com', 'muyoc.com', 'buxod.com', 'pidox.org', 'mecip.net', 'pudxe.com', 'xedmi.com', 'ludxc.com', 'juzab.com', 'klepf.com', 'matra.site', 'bombamail.icu', 'yermail.net', 'totallynotfake.net', 'techblast.ch', 'spamthis.network', 'spammy.host', 'spammer.fail', 'shadap.org', 'pewpewpewpew.pw', 'netcom.ws', 'itcompu.com', 'disposable.site', 'deinbox.com', 'sharklasers.com', 'guerrillamailblock.com', 'guerrillamail.org', 'guerrillamail.net', 'guerrillamail.de', 'guerrillamail.biz', 'grr.la', 'netmail.tk', 'laste.ml', 'firste.ml', 'zeroe.ml', 'supere.ml', 'emlhub.com', 'emlpro.com', 'emltmp.com', 'yomail.info', '10mail.org', 'wegwerfmail.org', 'wegwerfmail.net', 'wegwerfmail.de', 'trashmail.me', 'trashmail.io', 'trashmail.at', 'trash-mail.at', 'rcpt.at', 'proxymail.eu', 'objectmail.com', 'kurzepost.de', 'damnthespam.com', 'contbay.com', '0box.eu', 'marmaryta.space', '5y5u.com', '58as.com', 'firemailbox.club', 'mozej.com', 'mailna.co', 'mailna.in', 'mailna.me', 'mohmal.im', 'mohmal.in', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf', 'nospam.ze.tc', 'nomail.xl.cx', 'mega.zik.dj', 'speed.1s.fr', 'courriel.fr.nf', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'nedoz.com', 'nmagazinec.com', 'armyspy.com', 'vmani.com', 'discard.email', 'discardmail.com', 'discardmail.de', 'spambog.com', 'spambog.de', 'spambog.ru', '0btcmail.pw', '815.ru', 'knol-power.nl', 'hartbot.de', 'freundin.ru', 'smashmail.de', 's0ny.net', 'pecinan.net', 'budaya-tionghoa.com', 'lajoska.pe.hu', '1mail.x24hr.com', 'from.onmypc.info', 'now.mefound.com', 'mowgli.jungleheart.com', 'yourspamgoesto.space', 'pecinan.org', 'budayationghoa.com', 'CR.cloudns.asia', 'TLS.cloudns.asia', 'MSFT.cloudns.asia', 'B.cr.cloUdnS.asia', 'ssl.tls.cloudns.ASIA', 'sweetxxx.de', 'DVD.dns-cloud.net', 'DVD.dnsabr.com', 'BD.dns-cloud.net', 'YX.dns-cloud.net', 'SHIT.dns-cloud.net', 'SHIT.dnsabr.com', 'eu.dns-cloud.net', 'eu.dnsabr.com', 'asia.dnsabr.com', '8.dnsabr.com', 'pw.8.dnsabr.com', 'mm.8.dnsabr.com', '23.8.dnsabr.com', 'pecinan.com', 'disposable-email.ml', 'pw.epac.to', 'postheo.de', 'sexy.camdvr.org', 'Disposable.ml', '888.dnS-clouD.NET', 'adult-work.info', 'casinokun.hu', 'bangsat.in', 'wallus.casinokun.hu', 'trap-mail.de', 'umailz.com', 'panchoalts.com', 'gmaile.design', 'ersatzauto.ch', 'tempes.gq', 'cpmail.life', 'tempemail.info', 'coolmailcool.com', 'kittenemail.com', '99email.xyz', 'notmyemail.tech', 'm.cloudns.cl', 'twitter-sign-in.cf', 'anonymized.org', 'you.has.dating', 'ketoblazepro.com', 'kost.party', '0hio0ak.com', '4dentalsolutions.com', 't.woeishyang.com', 'ondemandemail.top', 'kittenemail.xyz', 'blackturtle.xyz', 'y.x.ssl.cloudns.asia', 'geneseeit.com', 'mailg.ml', 'media.motornation.buzz', 'sage.speedfocus.biz', 'badlion.co.uk', 'safeemail.xyz', 'virtual-generations.com', 'new-york.host', 'mrdeeps.ml', 'kitela.work', 'fouadps.cf', 'megacorp.work', 'fake-wegwerf.email', 'tigytech.com', 'historictheology.com', 'ma.567map.xyz', 'hotmailproduct.com', 'maxsize.online', 'happyfreshdrink.com', 'denomla.com', 'pansamantala.poistaa.com', 'sahaltastari.sytes.net', 'cecep.ddnsking.com', 'fadilmalik.ddnsking.com', 'csingi.sytes.net', 'richmail.ga', 'tikmail.gq', 'bupkiss.ml', 'guerrillamail.info', 'pokemail.net', 'myinbox.icu', 'just4fun.me', 'inscriptio.in', 'cloud-mail.top', 'safemail.icu', 'montokop.pw', 'tempamailbox.info', 'blogtron.com', 'atanetorg.org', 'aristockphoto.com', 'jomcs.com', 'kukuka.org', 'gothill.com', 'mixely.com', 'marsoasis.org', 'walmarteshop.com', 'outlandlabs.com', 'comectrix.com', 'buymondo.com', 'eventao.com', 'louieliu.com', 'mymailnow.xyz', 'cuoly.com', 'getnada.com', 'abyssmail.com', 'boximail.com', 'clrmail.com', 'dropjar.com', 'getairmail.com', 'givmail.com', 'inboxbear.com', 'robot-mail.com', 'tafmail.com', 'vomoto.com', 'zetmail.com']

export const page = async () => {
    // alert('funciona');
    //Swiper slider
    activeSlider();

    // Botones Slider Videos
    rightClick();
    leftClick();
    btnActiveRight();

    // Active Video
    activeVideo();
    closeVideo();
    
    //Active carrusel words
    carrueselWords();
    btnActiveCarruselWord();

    //hidden sticky
    hiddenSticky();

    AOS.init({
        once: true,
    });
    animationsSplit();

    // Loading progress bar from banner home
    loadingProgressBar();
    barClick();

    // Text empty marquee
    marqueeTextEmpty();
    buttonBanner();
}

const buttonBanner = () => {
    const banner = document.querySelector('.swiperBanner')
    const buttons = banner.querySelectorAll('.btn__shape')

    buttons.forEach(btn => {
        const href = btn.getAttribute('data-href')
        if (href.includes('youtube')) {
            modalToggle(btn);
        }

        else {
            btn.addEventListener('click', function () {
                window.location.href = href
            })
        }
    });
}

const modalToggle = (buttonOpen: HTMLElement) => {
    if (buttonOpen) {
        const idModal = buttonOpen.getAttribute('data-modal')
        const modal = document.querySelector(`.modalVideo[data-modal="${idModal}"]`)
        if (modal) {
            const close = modal.querySelector('.modalVideo-close');
            const videos = modal.querySelectorAll('iframe');
            
            buttonOpen.addEventListener('click', function () {
                if(videos) {
                    videos.forEach((video) => {
                        video.src = buttonOpen.dataset.href
                    })
                }
                if (modal) {
                    modal.classList.add('active');
                    document.querySelector('body').classList.add('no-scroll')
                }
            })

            if (modal && close) {
                close.addEventListener('click', function () {
                    modal.classList.remove('active');
                    document.querySelector('body').classList.remove('no-scroll')
    
                    if (videos) {
                        videos.forEach((video) => {
                            video.src = ''
                        })
                    }
                })
            }
        }

    }
}
// Reset Progrss Bar
function resetProgress() {
    const arrayBarProgress = document.querySelectorAll('.progressBar progress');
    [...arrayBarProgress].forEach( barProgress => {
        barProgress.value = 0;
    })
}
// Click specific progress bar
function barClick() {
    const arrayBars = document.querySelectorAll('.progressBar');
    [...arrayBars].map((bars, index) => {
        bars.addEventListener('click', element => {
            selectDots(index);
        })
    })
}
// Active progress bar selected
function selectDots(dotNumber:number) {
    const arrayDots = document.querySelectorAll('.swiper-pagination .swiper-pagination-bullet');
    [...arrayDots].map( (dot, index) => {
        if(index === dotNumber) {
            dot.click(); 
            loadingProgressBar(dotNumber);
        }
    })
}
function loadingProgressBar(num = 0) {
    const progressBar = document.querySelectorAll('.containerProgress progress');
    progressBar.forEach((e:any, index:any) => {
        if(index === num) {
            startBar(e);
        }
    })
}
let setI:any;
function startBar(e:any) {
    if(setI) {
        resetProgress();
        clearInterval(setI);
    }
    setI = setInterval(() => {
        e.value++ * 1;
        if(e.value == '100'){
            document.querySelector('.swiperBanner .swiper-button-next').click();
            clearInterval(setI);
            resetProgress();
            startOther(e);
        }
    }, 90);
}

function startOther(elemento:any) {
    if(elemento.parentElement.nextElementSibling) {
        startBar(elemento.parentElement.nextElementSibling.children[1]);
        return;
    }
    loadingProgressBar();
}

function hiddenSticky() {
    const btnSticky = document.querySelector('.closeSticky');
    btnSticky.addEventListener('click', e => {
        e.preventDefault();
        e.target.parentElement.classList.add('hidden');
        
    })
}

function marqueeTextEmpty() {
    const textArray = document.querySelectorAll('.marquee p');
    if( textArray ) {
        [...textArray].map( marquee => {
            let copyArray = marquee.textContent.split(' ');
            marquee.textContent = '';
            
            copyArray.forEach(e => {
                let pContainer = document.createElement('P');
                pContainer.textContent = e;
                pContainer.classList.add('textEmpty');
                marquee.appendChild(pContainer);
            })
        })
        
    }
}

function animationsSplit(){
    new SplitText(".contentTitle")
    new SplitText(".contentDesc p")
    new SplitText(".products__containerTitle")
    new SplitText(".products__description p")
    // new SplitText(".titleContent")
    // new SplitText(".textContent")
    // new SplitText(".textDeskop p")
}

function btnActiveCarruselWord() {
    const btnRight = document.querySelector('.swiperMixture .swiper-button-next');
    const btnPrev = document.querySelector('.swiperMixture .swiper-button-prev');
    btnRight && btnRight.addEventListener('click', nextBtn => {
        carrueselWords();
    });
    btnPrev && btnPrev.addEventListener('click', prevBtn => {
        carrueselWords();
    });
}

function carrueselWords() {
    const carrouselActive = document.querySelector('.swiperMixture .swiper-slide-active');
    const carrouselWordActive = document.querySelectorAll('.playGame .rotate .marquee')
    let wordSelected = carrouselActive && carrouselActive.classList[1];
    carrouselWordActive && carrouselWordActive.forEach( e => {
        e.classList.add('hidden');
        if(e.classList[1] === wordSelected) {
            e.classList.remove('hidden');
        }
        
    })
    
    
     
}


function clearContainer(contenedor) {
    while (contenedor.firstChild) {
        contenedor.removeChild(contenedor.firstChild);
    }
}


function activeVideo() {
    const videos = document.querySelectorAll('.play');
    if(videos) {
        [...videos].map( video => {
            video.addEventListener('click', abrirPopUp => {
                abrirPopUp.preventDefault();
                const modalVideo = document.querySelector('.modalVideo[data-modal="modal-mezclas"]');
                let videoCopy = abrirPopUp.target.closest('.contentVid').children[0];
                let srcVideo = videoCopy.dataset.srcmodal;
                let idVideoYT = srcVideo.split('/')[4];
                console.log(idVideoYT)
                
                YouTubeIframeLoader.load(function(YT) {
                    let player = new YT.Player('iframe-mezclas', {videoId: idVideoYT});
                    player.addEventListener('onReady', (event) => {
                        console.log('onReady funciona',event);
                        sendDatalayerYoutube()
                    })
                    console.log(player)
                    window.sendDatalayerYoutube = () => {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'trackEvent',
                            'eventCategory': 'Vickys Hub',
                            'eventAction': 'Play',
                            'eventLabel': player.getVideoData().title,
                        })
                    }
                });
                modalVideo.classList.add('active');
            })
        })
    }
}

function closeVideo() {
    const closeVideos = document.querySelectorAll('.btnClose');
    if(closeVideos) {
        [...closeVideos].map( closeVideo => {
            closeVideo.addEventListener('click', closePopUp => {
                closePopUp.preventDefault();
                closePopUp.target.closest('.modalVideo__container').children[1].children[0].remove();
                let div = document.createElement('div')
                div.setAttribute('id', 'iframe-mezclas')
                closePopUp.target.closest('.modalVideo__container').children[1].appendChild(div)
                closePopUp.target.closest('.modalVideo[data-modal="modal-mezclas"]').classList.remove('active');
            })
        })
    }
}

function rightClick() {
    const btnRight = document.querySelector('.swiperVideo .swiper-button-next');
    if(btnRight) {
        const newBtnRight = document.querySelector('.slider .btnSwiperRight');
        newBtnRight.addEventListener('click', e => {
            e.preventDefault();
            btnRight.click();
        })
    }
    
}

function leftClick() {
    const btnLeft = document.querySelector('.swiperVideo .swiper-button-prev');
    const newBtnLeft = document.querySelector('.slider .btnSwiperLeft');
    if(btnLeft) {
        newBtnLeft.addEventListener('click', e => {
            e.preventDefault();
            btnLeft.click();
        })
    }
}

function btnActiveRight() {
    const btnNextSlider = document.querySelector('.videos .btn');
    if(btnNextSlider) {
        const newBtnRight = document.querySelector('.slider .btnSwiperRight');
        btnNextSlider.addEventListener('click', e => {
            e.preventDefault();
            newBtnRight.click();
        })
    }
}

function activeSlider() {

    const swiperBanner = new Swiper(".swiperBanner", {
        modules: [Navigation, Pagination],
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        /*pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },*/
    });

    const arrayBars = document.querySelectorAll('.progressBar');
    const parent = document.querySelector('.banner__container');
    if (arrayBars.length <= 1) {
        parent.classList.add('hidden')
        swiperBanner.loopDestroy()
    }

    const swiperVideo = new Swiper(".swiperVideo", {
        modules: [Navigation, Pagination, EffectFade, Grid],
        // effect: "fade",
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // when window width is >= 480px
            991: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                slidesPerColumn: 3,
                direction: "vertical",
            }
        }
    });

    const swiperProducts = new Swiper(".swiperProducts", {
        slidesPerView: 1,
        spaceBetween: 30,
        modules: [Navigation, Pagination, Autoplay],
        pagination: {
        el: ".swiper-pagination",
        clickable: true,
        },
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false,
        // },
        breakpoints: {
            // when window width is >= 320px
            768: {
                slidesPerView: 2
            },
            // when window width is >= 480px
            991: {
                slidesPerView: 3
            }
        }
    });

    const swiperMixture = new Swiper(".swiperMixture", {
        modules: [Navigation, Pagination],
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    const swiperDetalle = new Swiper(".swiperDetalle", {
        slidesPerView: 1,
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // when window width is >= 480px
            991: {
                slidesPerView: 2
            }
        }
    });
    
}